import * as angular from 'angular'

import { Component } from '../../../shared/decorators'
import * as webserviceModels from '../../../shared/interfaces/webservice-models'
import {
  AcquirerListService,
  MerchantService,
  ResponseCodeListService,
  ToastHelperService,
} from '../../../shared/services'

@Component({
  selector: 'paymentOperations',
  template: require('./payment-operations.html'),
  bindings: {
    _operations: '<operations',
    isInitializing: '<',
    payment: '<',
  },
})
export class PaymentOperationsComponent {
  payment: webserviceModels.Merchant.transaction
  isInitializing: boolean

  // tslint:disable-next-line:variable-name
  private _operations: Array<webserviceModels.Merchant.transactionoperation>

  // tslint:disable-next-line:member-ordering
  static $inject = [
    '$mdDialog',
    '$mdMedia',
    'merchantService',
    'acquirerListService',
    'toastHelper',
    'gettextCatalog',
    'responseCodeListService',
  ]
  constructor(
    private $mdDialog: ng.material.IDialogService,
    private $mdMedia: ng.material.IMedia,
    private merchantService: MerchantService,
    private acquirerListService: AcquirerListService,
    private toastHelper: ToastHelperService,
    private gettextCatalog: ng.gettext.gettextCatalog,
    private responseCodeListService: ResponseCodeListService,
  ) {}

  get operations() {
    return this._operations
  }

  showOperationDetails(operation: webserviceModels.Merchant.transactionoperation, $event: MouseEvent) {
    this.$mdDialog.show({
      template: `
                <md-dialog class="modalDialog" flex="40" flex-gt-lg="30">
                    <operation-details operation="$ctrl.operation"></operation-details>
                </md-dialog>
            `,
      controller(this: any) {
        this.operation = operation
      },
      controllerAs: '$ctrl',
      targetEvent: $event,
      parent: angular.element(document.body),
      escapeToClose: false,
      clickOutsideToClose: false,
      fullscreen: !this.$mdMedia('gt-md'),
    })
  }

  getacquirerDisplayName(acquirerName: string) {
    return this.acquirerListService.getAcquirerDisplayNameFromAcquirerName(acquirerName)
  }

  getResponseCodeMerchantLabel(actionsource: string, actioncode: string) {
    let responseCode = this.responseCodeListService.getResponseCode(actionsource, actioncode)
    if (responseCode) {
      return responseCode.merchantlabel
    }

    return null
  }
}
